import {PageTemplate} from '../../shared/layout/PageTemplate';
import {DashboardComponent} from "./components/Dashboard";
import {useTranslation} from "react-i18next";

export function Dashboard() {
    const {t} = useTranslation()
    return <PageTemplate pageName={`${t('dashboard.dashboard')}`} title={`${t('dashboard.dashboard')}`}
                         content={<DashboardComponent/>}/>
}